import React, { useContext, useState, useEffect } from "react";
import { _t, getCookie } from "../../../../../functions/Functions";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { toast } from "react-toastify";
import { BASE_URL } from "../../../../../BaseUrl";

const MultiSettleModal = ({ multiSettleOrder, setMultiSettleOrder, setSearchedOrder, roundFormatPrice }) => {
  const { t } = useTranslation();
  const { authUserInfo } = useContext(UserContext);
  const {
    branchForListSearch,
    submittedOrders,
    paymentTypeForSearch,
    loading,
    setLoading,
  } = useContext(RestaurantContext);
  const [paymentTypeAvailable, setPaymentTypeAvailable] =
    useState(paymentTypeForSearch);

  useEffect(() => {
    if (multiSettleOrder.modal && multiSettleOrder.orders) {
      const order = multiSettleOrder.orders &&
        submittedOrders.data.find((item) => multiSettleOrder.orders?.[item.id]);
      const branch = branchForListSearch &&
        branchForListSearch[authUserInfo.details.branch_id];
        const paymentType = paymentTypeForSearch &&
          paymentTypeForSearch.filter((item) => {
            return (
              JSON.parse(order?.associate_with_payment_type)?.includes(item.id) && (branch
                ? (!branch?.payment_tax?.[item.name] || (branch.payment_tax?.[item.name] === branch.branch_tax))
                : !order?.payment_tax[item.name] || (order?.payment_tax[item.name] === order.theBranch.branch_tax))
            );
          });
      setPaymentTypeAvailable(paymentType);
    }
  }, [multiSettleOrder.modal]);

  const emptySettle = () => {
    setMultiSettleOrder({
      ...multiSettleOrder,
      payment_type: null,
      orders: null,
      modal: false,
      amount: 0,
    });
    setSearchedOrder((curr)=>({
      ...curr,
      list: null,
      searched: false,
    }))
    if(document.getElementById("multi_settle_check")){
      document.getElementById("multi_settle_check").checked = false;
    }
  };

  const handleSetPayment = (payment) => {
    setMultiSettleOrder({
      ...multiSettleOrder,
      payment_type: payment,
    });
  };

  //save multi settle
  const handleSaveMultiSettle = async (e) => {
    e.preventDefault();
    if(!multiSettleOrder?.payment_type){
      toast.error(`${_t(t("Please select payment type"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false;
    }
    const url = BASE_URL + "/settings/settle-multi-orders";
    const formData = {
      order_id: multiSettleOrder.orders
        ? Object.values(multiSettleOrder.orders)
        : [],
      payment_type: multiSettleOrder.payment_type?.name,
    };
    setLoading(true);
    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data) {
        setLoading(false);
        emptySettle();
        toast.success(`${_t(t(res.data.message))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    } catch (error) {
      setLoading(false);
      if (error?.response?.data && error.response.data?.status == 0) {
        toast.error(`${_t(t(error.response.data.message))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return false;
      }
      toast.error("Please try again", {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  return (
    <>
      <div
        className={`modal fade ${
          multiSettleOrder.modal !== false ? "showing" : ""
        }`}
        id="multisettle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md my-auto">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="w-100 d-flex align-items-center justify-content-center">
                <div className="rider-text">Multi Settle Order</div>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={emptySettle}
                ></button>
              </div>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              <div key="fragment-food-group-1">
                <form
                  className="my-1 rounded-lg"
                  onSubmit={(e) => handleSaveMultiSettle(e)}
                  autoComplete="off"
                >
                  <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded mb-2 border">
                      <span className="font-weight-bold text-dark" style={{ fontSize: "1.1rem" }}>{_t(t("Total Payable Amount"))}</span>
                      <span className="font-weight-bold text-primary" style={{ fontSize: "1.25rem" }}>
                        {roundFormatPrice ? roundFormatPrice(multiSettleOrder.amount || 0) : Number(multiSettleOrder.amount || 0).toFixed(2)}
                      </span>
                    </div>
                    <label
                      htmlFor="recipient-name"
                      className="col-form-label font-weight-md class-variants ml-2 mb-2"
                    >
                      Select Payment Type
                    </label>
                    <div
                      className="mb-1 bill_modal_scroll"
                      style={{ maxHeight: "14rem" }}
                    >
                      <div className="row m-0">
                        {paymentTypeAvailable &&
                          paymentTypeAvailable.map((item, index) => {
                            return (
                              <div
                                key={index}
                                className="col-6 mb-2 text-break"
                              >
                                <button
                                  type="button"
                                  className={`w-100 btn ${
                                    item.id ===
                                    multiSettleOrder.payment_type?.id
                                      ? "btn-primary"
                                      : "btn-outline-primary"
                                  } table-text`}
                                  onClick={() => handleSetPayment(item)}
                                >
                                  {item.name}
                                </button>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 d-flex justify-content-end mb-2">
                    <button
                      disabled={loading}
                      className="btn btn-success text-center px-4 text-uppercase rounded"
                      type="submit"
                    >
                      {_t(t("Save"))}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MultiSettleModal;
